import { useStoreConnect } from '../../common/hooks/useStoreConnect'
import { inputActions, outputActions } from '../../api/actions/actionsLists'
import { useCallback, useEffect, useState } from 'react'
import { AppStore, getStore } from '@wellesley/store'
import { usePreloadedStore } from './usePreloadedStore'
import { staticState } from '../../common/staticState'
import { callRemoteApiAction } from '../api'
import { initializeThemeSync } from '../../api/actions/theme'

const { path, search } = staticState.init()
path && window.history.replaceState({}, '', `${path}${search || ''}`)

export const useRemoteStoreConnect = () => {
  const [store, setStore] = useState<AppStore | null>(null)

  const connect = useStoreConnect({
    sendWhitelist: inputActions,
    receiveWhitelist: outputActions,
    onMessage: (action) =>
      void (callRemoteApiAction(action) || getStore().dispatch(action)),
  })

  const onStoreCreated = useCallback(
    (store: AppStore) => {
      setStore(store)
      connect(window.parent)
    },
    [connect],
  )

  useEffect(() => initializeThemeSync(), [])

  usePreloadedStore(onStoreCreated)

  return { store, path }
}
